const baseUrl = "https://x1cslrnasf.execute-api.ap-south-1.amazonaws.com/dev/api/user/"
// const baseUrl = "http://localhost:5000/dev/api/user/"

export const getAllCompanyNAME = baseUrl+"getCompany?company="
export const geRegisteredUsers = baseUrl+"getAdminRegistered"
export const geRegisteredUserInfo = baseUrl+"getUser/"
export const editUserInfo = baseUrl+"editUser/"
